<template>
  <div class="cost-breakdown">
    <div class="cost-breakdown-body">
      <SearchCollapse @update-height="getHeight" :formItemsLength="14">
      <div ref="searchBox" class="formBox">
        <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="90px" size="mini">
            <div class="formItemBox">
          <el-form-item label="捆包编号:">
            <el-input placeholder="可支持多个" type="textarea" v-model="formData.cargoBarcodes"  size="mini" ></el-input>
          </el-form-item>
          <el-form-item label="出库车牌号:">
            <el-input v-model="formData.outstockPlateNumber" placeholder="请输入" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="出库开始日:">
            <el-date-picker v-model="formData.outstockDateStart" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="出库结束日:">
            <el-date-picker v-model="formData.outstockDateStartEnd" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="规格:">
            <el-input v-model="formData.specification" placeholder="请输入" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="出库司机:">
            <el-input v-model="formData.driverName" placeholder="请输入" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="结算客户:">
            <el-select v-model="formData.payCustomerNameTaxId" size="mini" placeholder="请选择" filterable clearable>
              <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.itemNo">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货物类型:">
            <el-select v-model="formData.productType" size="mini" placeholder="请选择" filterable clearable>
              <el-option v-for="(item, index) in productOptions" :key="index" :label="item.show_name" :value="item.item_no"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="结算状态:">
            <el-select v-model="formData.feeState" size="mini" placeholder="请选择" filterable clearable>
              <el-option v-for="(item, index) in jiesuanOptions" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出库单:">
            <el-input v-model="formData.outstockNo" placeholder="请输入" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="客户名称:">
            <el-select size="mini" filterable clearable v-model="formData.customerNameTaxId" placeholder="请选择">
              <el-option v-for="(item,index) in kehuMing" :label="item.custerName" :key="index" :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入库客户:">
            <el-select size="mini" filterable clearable v-model="formData.inCustomerTaxId" placeholder="请选择">
              <el-option v-for="(item,index) in kehuMing" :label="item.custerName" :key="index" :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同编号:">
            <el-input v-model="formData.contractNumber" placeholder="请输入" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="结算部门:" prop="payDepartment" >
            <el-select v-model="formData.payDepartment" size="mini" placeholder="请选择" filterable clearable >
              <el-option v-for="(item, index) in bumeList" :key="index" :label="item.showName"
                :value="item.showName">
              </el-option>
            </el-select>
          </el-form-item>
         </div>
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun" v-if="btnFlg[0]" btnCode="003P01dB001">查询</el-button>
            <el-button type="primary" size="mini" @click="chongzhi" v-if="btnFlg[1]" btnCode="003P01dB002">重置</el-button>
            <el-button type="primary" size="mini" @click="daochu" v-if="btnFlg[2]" btnCode="003P01dB003">导出</el-button>
            <el-button type="primary" size="mini" @click="xiugai" v-if="btnFlg[5]">修改结算客户</el-button>
            <el-button type="primary" size="mini" @click="xiugaidanjiaFN" v-if="btnFlg[9]">修改单价</el-button>
            <!-- <span style="margin-left:10px">总吨数：<span style="color:red">{{ allWeight}}</span> 吨</span> -->
            <span style="margin-left:10px">费用合计：<span style="color:red">{{ HeJi }}</span> 元</span>
            <span style="margin-left:10px">总重量：<span style="color:red">{{ Weight }}</span> 吨</span>
          </el-form-item>
        </el-form>
      </div>
       </SearchCollapse>
      <!-- 表格 -->
      <div :style="{ height: h }">
        <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData" style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row @selection-change="selectGoods">
          <el-table-column type="selection" align="center" width="40"></el-table-column>
          <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" v-for="item in titleList" :key="item.titleName" :prop="item.titleId instanceof Array ?'':item.titleId" :label="item.titleName" align="center" :width="item.titleId=='customerName'||item.titleId=='cargoBarcode'||item.titleId=='payCustomerName'||item.titleId=='outstockNo'||item.titleId=='instockDate'||item.titleId=='outstockDate'||item.titleId=='contractNumber'||item.titleId=='agreementNumber'||item.titleId=='inCustomerName'?220:120">
            <template v-if="item.titleId instanceof Array ? true : false">
              <el-table-column v-for="i in item.titleId" :key="i.titleId" :prop="i.titleId" :label="i.titleName"></el-table-column>
            </template>
          </el-table-column>
          <!-- <el-table-column :show-overflow-tooltip="true" prop="payCustomerName" label="结算单位" align="center" width="250"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)" align="center" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="feeType" label="费用类型" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="unitPrice" label="单价" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="amount" label="金额" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="stockDay" label="库存天数" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="changeNumber" label="转货次数" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="overdueDay" label="超期天数" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="feeStateName" label="结算状态" align="center" width="120">
          <template v-slot="scoped">
            <span v-if='scoped.row.feeStateName=="未收款"' style="color:red">{{scoped.row.feeStateName}}</span>
            <span v-else-if="scoped.row.feeStateName == '已收款'" style="color:green">{{scoped.row.feeStateName}}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="payCustomerName" label="结算客户" align="center" width="250"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="ext1" label="到货方式" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="outstockPlateNumber" label="出库车牌" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="driverName" label="出库司机" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="outstockNo" label="出库单" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="outstockDate" label="出库时间" align="center" width="200"></el-table-column> -->
        </el-table>
      </div>
      <div class="pags" style="text-align: right">
        <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
      </div>
    </div>
    <!--点击查看凭证-->
    <div class="addMarkBox">
      <el-dialog title="查看图片" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="60%" center>
        <!-- <div v-if="!imgFlag">
            <div>无货损图片</div>
          </div>-->
        <div class="img_box">
          <div v-for="(item, index) in imgData" :key="index">
            <img :src="item.url" alt />
            <!-- <i v-if="seen" class="el-icon-delete" @click="delImg(item)"></i> -->
            <i class="el-icon-zoom-in" @click="handChange(item.url)"></i>
          </div>
        </div>
        <el-dialog class="oneTwo" :visible.sync="dialogVisible" title="查看凭证" append-to-body width="40%" center :close-on-click-modal="false">
          <div class="imgDialog">
            <img :src="imageD" alt />
          </div>
        </el-dialog>
        <div style="width: 158px; margin: 15px auto"></div>
      </el-dialog>
    </div>
    <!-- 修改结算客户 -->
    <div>
      <el-dialog title="修改结算客户" :visible.sync="XGKHvisible" :close-on-click-modal="false" @close="XGKHvisible=false" width="40%" center>
        <!--form表单-->
        <el-form :model="KHFormData" ref="KHFormData" label-width="150px" class="demo-dynamic" style="width:350px;margin:30px auto;">
          <el-form-item prop="payCustomerNameTaxId" label="结算客户：" :rules="[
              { required: true, message: '请选择结算客户', trigger: 'change' },
            ]">
            <el-select v-model="KHFormData.payCustomerNameTaxId" size="mini" placeholder="请选择" filterable clearable>
              <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.itemNo">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="XGKHvisible = false">取 消</el-button>
          <el-button type="primary" @click="XGKH()" :loading="addLoad">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <el-dialog title="修改单价" :visible.sync="XGDJvisible" :close-on-click-modal="false" @close="XGDJvisible=false" width="500px" center>
        <!--form表单-->
        <el-form :model="DJFormData" ref="DJFormData"  :rules="rules" label-width="150px" class="demo-dynamic jiaoyan" style="width:350px;margin:30px auto;">
          <el-form-item label="仓储费:" prop="storageUnitPrice">
            <el-input v-model="DJFormData.storageUnitPrice" v-number-input.float="3" placeholder="请输入"
              size="mini" style="width:135px;vertical-align:top;"><span slot="suffix">元/吨</span></el-input>
          </el-form-item>
          <el-form-item label="超期费:" prop="overdueUnitPrice">
            <el-input v-model="DJFormData.overdueUnitPrice" v-number-input.float="3" placeholder="请输入"
              size="mini" style="width:135px;vertical-align:top;"><span slot="suffix">元/吨/天</span></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="XGDJvisible = false">取 消</el-button>
          <el-button type="primary" @click="JSDJsaveFn()" :loading="addLoad1">确 定</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import {
  zidian,
  zidianKuwei, // 字典库位
  zidianQuwei, // 字典区位
  zidianHuowei, // 字典货位
  JfgetStorageFeeList,
  JfgetStorageFeeWeightAllfee,
  updatePayCustomer,
  getRelationCustomer,
  getStorageFeeNumber,
  sFUpdateUnitPrice,
  getPayDepartment
} from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import { exportExcel } from '@/utils/fileDown.js'
import { getBtn } from '@/utils/getButton'

import {
  getCargoDamagePicture // 查看图片
} from '@/api/wms-access'
import {
  getQueryCusterData // 客户
} from '@/api/platform-settlement'
import SearchCollapse from '@/components/common/SearchCollapse.vue'
export default {
  components: { SearchCollapse },
  name: 'costBreakdown',
  data () {
    return {
      formData: {
        cargoBarcodes: '',
        outstockPlateNumber: '',
        outstockDateStart: '',
        outstockDateStartEnd: '',
        outstockNo: '',
        specification: '',
        driverName: '',
        payCustomerNameTaxId: '',
        productType: '',
        feeState: '0',
        customerNameTaxId: '',
        inCustomerTaxId: '',
        contractNumber: ''
      },
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      jiesuanOptions: [
        { id: '', name: '全部' },
        { id: '0', name: '未收款' },
        { id: '1', name: '已收款' }
      ],
      productOptions: [],
      addKuwei: [],
      addQ: [],
      addH: [],
      tableData: [],
      titleList: [],
      h: '500px',
      // xuanzhongArr: null,
      total: 0,
      allWeight: 0,
      HeJi: 0,
      addMarkLookBox: false,
      imageD: '',
      dialogVisible: false,
      imgData: [],
      keHuOptions: [],
      btnFlg: [],
      btnIdArr: ['003P01dB001', '003P01dB002', '003P01dB003', '003M310100', '003M310200', '003M310300', '003M310400', '003M310500', '003M310600', '003M310800'],
      feeTypeOptions: [],
      KHFormData: {
        payCustomerNameTaxId: ''
      },
      XGKHvisible: false,
      addLoad: false,
      payCustomerName: '',
      selectTable: [],
      kehuMing: [],
      Weight: 0,
      XGDJvisible: false,
      DJFormData: {},
      addLoad1: false,
      rules: {
        storageUnitPrice: [
          { required: true, message: '请输入仓储费', trigger: 'blur' }
        ],
        overdueUnitPrice: [
          { required: true, message: '请输入超期费', trigger: 'blur' }
        ]
      },
      bumeList: []
    }
  },
  methods: {
    // 总重量
    getStorageFeeNumber () {
      getStorageFeeNumber(
        {
          cargoBarcodes: this.formData.cargoBarcodes,
          outstockPlateNumber: this.formData.outstockPlateNumber,
          outstockDateStart: this.formData.outstockDateStart,
          outstockDateStartEnd: this.formData.outstockDateStartEnd,
          outstockNo: this.formData.outstockNo,
          specification: this.formData.specification,
          driverName: this.formData.driverName,
          payCustomerNameTaxId: this.formData.payCustomerNameTaxId,
          productType: this.formData.productType,
          feeState: this.formData.feeState,
          customerNameTaxId: this.formData.customerNameTaxId,
          inCustomerTaxId: this.formData.inCustomerTaxId,
          contractNumber: this.formData.contractNumber,
          payDepartment: this.formData.payDepartment
        }
      )
        .then(res => {
          console.log(res)
          this.Weight = res.weight
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.kehuMing = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    selectGoods (selection) {
      console.log(selection)
      this.selectTable = selection
    },
    xiugaidanjiaFN () {
      let isHQ = false
      const selectData = this.$refs.tabref1.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.DJFormData = {}
        this.DJFormData.storageFeeIds = []
        this.DJFormData.feeOverdueIds = []
        selectData.some((item, index) => {
          if (item.feeState == 1) {
            this.$alert('所选数据有已付款的数据', '系统提示')
            isHQ = false
            return false
          } else {
            if (index != 0) {
              let n = index - 1
              if (selectData[n].customerName != item.customerName) {
                this.$alert('所选数据客户名称不一样', '系统提示')
                isHQ = false
                return false
              } else {
                isHQ = true
                this.DJFormData.storageFeeIds.push(item.storageFeeId)
                this.DJFormData.feeOverdueIds.push(item.feeOverdueId)
              }
            } else {
              isHQ = true
              this.DJFormData.storageFeeIds.push(item.storageFeeId)
              this.DJFormData.feeOverdueIds.push(item.feeOverdueId)
            }
          }
        })
      }
      if (isHQ) {
        this.$nextTick(() => {
          this.$refs.DJFormData.clearValidate()
        })
        this.XGDJvisible = true
      }
    },
    JSDJsaveFn () {
      this.$refs.DJFormData.validate((valid) => {
        if (valid) {
          this.addLoad1 = true
          this.DJFormData.storageFeeIds = this.DJFormData.storageFeeIds.toString()
          this.DJFormData.feeOverdueIds = this.DJFormData.feeOverdueIds.toString()
          sFUpdateUnitPrice(this.DJFormData).then(res => {
            this.addLoad1 = false
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.XGDJvisible = false
            this.JfgetStorageFeeLists()
            this.JfgetStorageFeeWeightAllfee()
          }).catch(error => {
            this.addLoad1 = false
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {

              }
            })
          })
        }
      })
    },
    // 修改结算客户
    xiugai () {
      let flag = this.selectTable.some(item => item.feeMasterId != undefined)

      this.KHFormData.payCustomerNameTaxId = ''
      if (this.selectTable.length == 0) {
        this.$message.error('请选中一条数据')
      } else if (this.selectTable[0].feeState == '1') {
        this.$message.error('已收款的不允许修改结算客户')
      } else if (flag) {
        this.$message.error('已创建账单的不允许修改结算客户')
      } else {
        this.XGKHvisible = true
        this.$nextTick(() => {
          this.$refs.KHFormData.clearValidate()
        })
        this.getQueryCusterData()
      }
    },
    XGKH () {
      this.$refs.KHFormData.validate((valid) => {
        if (valid) {
          this.addLoad = true
          let ids = this.selectTable.map(item => item.feeDetailId)
          console.log(ids)
          this.payCustomerName = this.keHuOptions.filter(item => item.itemNo == this.KHFormData.payCustomerNameTaxId)[0].showName
          this.KHFormData.payCustomerNameTaxId = this.keHuOptions.filter(item => item.itemNo == this.KHFormData.payCustomerNameTaxId)[0].itemNo
          updatePayCustomer(
            {
              feeDetailIds: ids.join(','),
              ...this.KHFormData,
              payCustomerName: this.payCustomerName
            }
          )
            .then(res => {
              console.log(res)
              this.addLoad = false
              this.XGKHvisible = false
              this.JfgetStorageFeeLists()
              this.JfgetStorageFeeWeightAllfee()
            })
            .catch(error => {
              DonMessage.error(error.message)
              this.addLoad = false
            })
        } else {
          this.addLoad = false
        }
      })
    },
    // 查看凭证-放大
    handChange (url) {
      this.imageD = url
      this.dialogVisible = true
    },
    // 图片查看
    imgShow (row) {
      this.addMarkLookBox = true
      getCargoDamagePicture({
        cargoId: row.cargoId // 货物id
      })
        .then((res) => {
          this.imgData = []
          this.imgData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 列表查询
    JfgetStorageFeeLists () {
      this.formData.cargoBarcodes = this.formData.cargoBarcodes.replace(/\n/g, ',')
      this.formData.cargoBarcodes = this.formData.cargoBarcodes.split(',').filter(item => item != '').join(',')
      JfgetStorageFeeList(
        {
          cargoBarcodes: this.formData.cargoBarcodes,
          outstockPlateNumber: this.formData.outstockPlateNumber,
          outstockDateStart: this.formData.outstockDateStart,
          outstockDateStartEnd: this.formData.outstockDateStartEnd,
          outstockNo: this.formData.outstockNo,
          specification: this.formData.specification,
          driverName: this.formData.driverName,
          payCustomerNameTaxId: this.formData.payCustomerNameTaxId,
          productType: this.formData.productType,
          feeState: this.formData.feeState,
          customerNameTaxId: this.formData.customerNameTaxId,
          inCustomerTaxId: this.formData.inCustomerTaxId,
          pageNo: this.pageInfo.pageNo,
          pageSize: this.pageInfo.pageSize,
          contractNumber: this.formData.contractNumber,
          payDepartment: this.formData.payDepartment
        }
      )
        .then(res => {
          console.log(res)
          this.tableData = res.feeList.list
          this.titleList = res.titleList
          this.total = res.feeList.total
          // this.JfgetStorageFeeWeightAllfee()
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    JfgetStorageFeeWeightAllfee () {
      JfgetStorageFeeWeightAllfee({
        cargoBarcodes: this.formData.cargoBarcodes,
        outstockPlateNumber: this.formData.outstockPlateNumber,
        outstockDateStart: this.formData.outstockDateStart,
        outstockDateStartEnd: this.formData.outstockDateStartEnd,
        outstockNo: this.formData.outstockNo,
        specification: this.formData.specification,
        driverName: this.formData.driverName,
        payCustomerNameTaxId: this.formData.payCustomerNameTaxId,
        productType: this.formData.productType,
        feeState: this.formData.feeState,
        customerNameTaxId: this.formData.customerNameTaxId,
        inCustomerTaxId: this.formData.inCustomerTaxId,
        contractNumber: this.formData.contractNumber,
        payDepartment: this.formData.payDepartment
      })
        .then(res => {
          console.log(res)
          this.HeJi = res.totalFee
          this.allWeight = res.allWeight
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    chaxun () {
      this.JfgetStorageFeeLists()
      this.JfgetStorageFeeWeightAllfee()
      this.getStorageFeeNumber()
    },
    chongzhi () {
      this.formData.cargoBarcodes = ''
      this.formData.outstockPlateNumber = ''
      this.formData.outstockDateStart = ''
      this.formData.outstockDateStartEnd = ''
      this.formData.outstockNo = ''
      this.formData.specification = ''
      this.formData.driverName = ''
      this.formData.payCustomerNameTaxId = ''
      this.formData.productType = ''
      this.formData.feeState = '0'
      this.formData.customerNameTaxId = ''
      this.formData.inCustomerTaxId = ''
      this.formData.contractNumber = ''
      this.$set(this.formData, 'payDepartment', '')
      this.JfgetStorageFeeLists()
      this.JfgetStorageFeeWeightAllfee()
      this.getStorageFeeNumber()
    },
    daochu () {
      this.formData.cargoBarcodes = this.formData.cargoBarcodes.replace(/\n/g, ',')
      this.formData.cargoBarcodes = this.formData.cargoBarcodes.split(',').filter(item => item != '').join(',')
      exportExcel(
        this.global.wmsStockName + '/storageFee/exportStorageFeeList',
        { ...this.formData },
        '费用明细'
      )
    },
    zidianS () {
      zidian({
        groupNo: 'product_type'
      })
        .then(res => {
          this.productOptions = res
        })
        .catch(err => {
          console.log(err)
        })
      zidian({
        groupNo: 'fee_type'
      })
        .then(res => {
          this.feeTypeOptions = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({})
        .then(res => {
          this.addKuwei = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 字典--区位
    zidianQuweiS () {
      zidianQuwei({
        warehouseId: this.kuweiId || this.kuweiIds
      })
        .then(res => {
          this.addQ = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 字典--货位
    zidianHuoweiS () {
      zidianHuowei({
        locationid: this.QId || this.QIds
      })
        .then(res => {
          this.addH = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取库位下拉框其他值
    changeXiugaiKW: function (valueS) {
      let choosenKuwei = this.addKuwei.filter(
        item => item.warehouseId === valueS
      )[0]
      this.kuweiId = choosenKuwei.warehouseId
      this.kuweiName = choosenKuwei.warehouseName
      this.quWeiName = ''
      this.huoWeiName = ''
      this.QId = ''
      this.HId = ''
      zidianQuwei({
        warehouseId: this.kuweiId
      })
        .then(res => {
          this.addQ = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取区位下拉框其他值
    changeXiugaiQW: function (valueS) {
      let choosenQ = this.addQ.filter(item => item.locationId === valueS)[0]
      this.QId = choosenQ.locationId
      this.QName = choosenQ.locationName
      this.huoWeiName = ''
      this.HId = ''
      zidianHuowei({
        locationid: this.QId
      })
        .then(res => {
          this.addH = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    // dianjixuanzhong (row) {
    //   this.xuanzhongArr = {}
    //   this.xuanzhongArr = row
    //   // this.JfgetThreadDetailExpLists()
    // },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    // 获取所属客户数据
    getQueryCusterData () {
      getQueryCusterData().then(res => {
        this.keHuOptions = res
      }).catch(err => {
        this.$message({ message: err.message, type: 'error' })
      })
    },
    getHeight () {
      this.$nextTick(() => {
        let h = this.$refs.searchBox.offsetHeight
        let pH = document.documentElement.clientHeight
        this.h = pH - h - 210 + 'px'
      })
    }
  },
  created () {
    this.getStorageFeeNumber()
    this.getRelationCustomerS()
    this.JfgetStorageFeeLists()
    this.JfgetStorageFeeWeightAllfee()
    this.btnFlg = getBtn(this.btnIdArr, '/costBreakdown')
    getPayDepartment().then(res => {
      this.bumeList = res
    }).catch(error => {
      DonMessage.error(error.message)
    })
  },
  mounted () {
    this.getHeight()
    this.getQueryCusterData()

    this.zidianKuweiS()
    this.zidianS()
    this.zidianQuweiS()
    this.zidianHuoweiS()
  }
}
</script>

<style lang="less" scoped>
/deep/.el-form-item {
  margin-bottom: 0px;
}
/deep/.jiaoyan .el-form-item{
   margin-bottom: 16px;
}
/deep/.el-date-editor .el-input__inner {
  width: 150px;
}
  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}
.formItemBox /deep/.el-form-item__content .el-date-editor{
  width: 100%!important;
  .el-input__inner{
    width: 100%!important;
  }
}
</style>
